import { defineStore } from 'pinia'
import { type Component, computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import DesktopDesignPanel from '@/components/DesktopDesignPanel.vue'
import FunctionalPanel from '@/components/FunctionalPanel.vue'
import { Route } from '@/router/route'

export function setCssVariable(key: string, value: string): void {
  document.documentElement.style.setProperty(key, value)
}

export type LayoutType = 'desktop' | 'mobile'
export function currentRootContainerForPanel(layoutType: LayoutType): Component {
  return layoutType === 'mobile' ? FunctionalPanel : DesktopDesignPanel
}

export const useLayoutStore = defineStore('layout', () => {
  const MOBILE_SIZE = 900
  const mediaType = ref<LayoutType>()
  const windowWidth = ref(0)
  onMounted(() => {
    window.addEventListener('resize', () => {
      handleWindowSizeChange()
    })
    handleWindowSizeChange()
  })
  function handleWindowSizeChange(): void {
    windowWidth.value = window.innerWidth
    mediaType.value = window.innerWidth >= MOBILE_SIZE ? 'desktop' : 'mobile'
    // setEmptyAreaWidth
    const emptyAreaWidth = Math.max((window.innerWidth - MOBILE_SIZE) / 2, 0)
    setCssVariable('--empty-area-width', `${emptyAreaWidth}px`)
    // setVh
    setCssVariable('--real1dvh', `${window.innerHeight / 100}px`)
  }
  const isMobile = computed(() => mediaType.value === 'mobile')
  const isDesktop = computed(() => mediaType.value === 'desktop')

  const route = useRoute()
  const isRwdPage = computed(() => {
    const routes: string[] = [
      Route.ArtistPage,
      Route.GalleryPage,
      Route.ArtistsPage,
      Route.FavoriteArtworkPage,
      Route.DevelopPage,
      Route.DesignPage,
      Route.DesignArtistPage,
      Route.IpCollabDesignPage,
      Route.CheckoutPage,
    ]
    if (route.name === undefined) return false
    const name: string = route.name.toString()
    return routes.includes(name)
  })

  // todo(chili): 這邊可以直接讓 header watch FavoriteArtwork，就不用經過 store 處理
  const animateHeartTriggerSignal = ref(0)
  function animateHeart(): void {
    animateHeartTriggerSignal.value = Date.now()
  }

  return {
    mediaType,
    windowWidth,
    MOBILE_SIZE,
    isMobile,
    isDesktop,
    isRwdPage,
    animateHeartTriggerSignal,
    animateHeart,
  }
})
